import { Component, OnInit } from '@angular/core';
import { TokenService } from '../services/token.service';
import { Router } from '@angular/router';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isAuthenticated = false;
  selectedTab: 'contacts' | 'history' = 'contacts';
  
  constructor(
    private tokenService: TokenService,
    private logService: LogService,
    private router: Router,
  ) { 
      this.isAuthenticated = this.tokenService.isEveportalJwtTokenValid() && this.tokenService.isRefreshTokenValid();
   }

  ngOnInit() {
  }

  logout() { 
    this.tokenService.clearAllTokens();
    this.router.navigate(['/login']);
  }

   downloadEncryptedLog() {
    this.logService.downloadAllLogsAsZip();
  }
}
